import axios from 'axios';

export const validateEmail = (email) => {             //Mail Validation Fun
    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{1,3}$/;
    console.log(emailRegex.test(email))
    return emailRegex.test(email);
};